import React from "react";
import { params } from "../utils/stocks";
import StockItem from "./StockItem";

function StockSection() {
  return (
    <div className="tokyo_tm_pricing" data-cursor-exclusion={true}>
        <div className="container">
            <div className="tokyo_section_title">
                <h3>Stocks</h3>
            </div>
            <div className="list">
                <ul>
                    {params.map((param) => (
                        <StockItem 
                            param={param}
                            key={param.id}
                        />
                    ))}
                    
                </ul>
            </div>
        </div>
    </div>
  );
}

export default StockSection;